export default __webpack_public_path__ + "eFeedback.html";